import React from "react";
import "./collapseTables.css";
import { ClosedCollapse } from "../../../../../assets";
import { Collapse } from "reactstrap";

const CollapseTables = ({ children, title, open, toggle }) => {
  const className = () =>
    open
      ? "collapse-tables-rotate collapse-tables-collapse-icon"
      : "collapse-tables-collapse-icon";

  return (
    <div className="collapse-tables-main-container">
      <div onClick={toggle} className="collapse-tables-title-clickable ">
        <ClosedCollapse className={className()} /> {title}
      </div>
      <Collapse isOpen={open}>{children}</Collapse>
    </div>
  );
};

export default CollapseTables;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/all-client-details/CollapseTables.jsx